import { render, staticRenderFns } from "./Datatype.vue?vue&type=template&id=ec4c079c&"
import script from "./Datatype.vue?vue&type=script&lang=js&"
export * from "./Datatype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports